import { RootState } from '../../rootReducer';

export const pdfSelectors = {
  getPDFData: (state: RootState) => state.PDFState,
};
